import ItemImageService from '@/services/admin/itemImages.service'
import router from '@/router'

const state =  {
}

const getters = {
}

const actions = {
    async getImagesWaitingForProcess({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await ItemImageService.getImagesWaitingForProcess(payload);

            return response
        } catch (e) {
            console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
    async uploadImagesToCloud({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await ItemImageService.uploadImagesToCloud(payload);

            return response
        } catch (e) {
            console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
    async fileOperation({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await ItemImageService.fileOperation(payload);

            return response
        } catch (e) {
            console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
    async getTotalImageRpt({commit}, payload) {
        try {
            // console.log(payload)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await ItemImageService.getTotalImageRpt(payload);
            commit('setLoading', false, { root: true })            


            return result
        } catch (e) {
            // console.log(e)
            return e
        }
    },
    async searchItemImageAdvanced({commit}, payload) {
        try {
            // console.log(payload)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await ItemImageService.searchItemImageAdvanced(payload);
            commit('setLoading', false, { root: true })            


            return result
        } catch (e) {
            // console.log(e)
            return e
        }
    },
    async deleteItemImage({commit}, payload) {
        try {
            // console.log(payload)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await ItemImageService.deleteItemImage(payload);
            commit('setLoading', false, { root: true })            


            return result
        } catch (e) {
            // console.log(e)
            return e
        }
    },
    async updateItemImageHidenRoles({commit}, payload) {
        try {
            // console.log(payload)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await ItemImageService.updateItemImageHidenRoles(payload);
            commit('setLoading', false, { root: true })            


            return result
        } catch (e) {
            // console.log(e)
            return e
        }
    },

}

const mutations = {
}

export const adminItemImages = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}